import * as React from "react"
import {useEffect} from "react"
import {Grid} from "@mui/material";

import {HOME_ROUTES, REPRICING_ROUTES} from "@constants"
import PageWrapper from "Pages/@PageWrapper"
import {clearRepricingHomeSignals} from "../@signals";
import RepricingAlertsBlock from "./AlertsBlock";
import RepricingNotifications from "./Notifications";
import RepricingPageWrapperActions from "./Actions";
import RepricingNotificationsTabs from "./Tabs";


export default function RepricingHomePage() {

	useEffect(() => {
		return clearRepricingHomeSignals
	}, []);

	return <PageWrapper
		head={`DIP Insight | ${REPRICING_ROUTES.TITLE}`}
		title={REPRICING_ROUTES.TITLE}
		subtitle={REPRICING_ROUTES.SUBTITLE}
		actions={<RepricingPageWrapperActions />}
	>
		<Grid container spacing={2}>
			<RepricingAlertsBlock />

			<Grid item xs={12}>
				<RepricingNotificationsTabs />
			</Grid>

			<Grid item xs={12}>
				<RepricingNotifications />
			</Grid>
		</Grid>
	</PageWrapper>
}